<template lang="html">
  <section class="bible-results" id="bible-results">
    <ResultsHeading 
      v-if="!showNoResults" 
      :resultsNum="countResults" 
      :more="additionalResults"
      :listDisplayed="currentWordList"
    ></ResultsHeading>
    <div v-if="showNoResults" class="no-results">לא נמצאו תוצאות</div>
    <div v-else class="frame-area bg-white">
      <BibleResultsList  
        @biblicalResults="updateCount('countItems', ...arguments)"
        @word-list="(list) => currentWordList=list"  
      />
    </div>
  </section>
</template>

<script lang="js">
  import ResultsHeading from '@/components/ResultsHeading'
  import BibleResultsList from '@/components/BibleResultsList'
  
  export default  {
    name: 'BibleResults',
    components: {ResultsHeading, BibleResultsList},
    props: [],
    mounted() {
   
    },
    data() {
      return {        
        countResults: 0,
        additionalResults: false,
        showNoResults: false,
        currentWordList: []
      }
    },
    methods: {
      updateCount: function(countItems, value, fMore) {
        this.additionalResults = fMore
        this.countResults = value
        this.showNoResults = value < 1
      }
    },
    computed: {
      searchWord: function () {
        return this.$store.state.textForCharuzitApiCall
      },      
      loading: function() {
        return this.$store.state.charuzitApiState
      },
      hebrew () {
        return this.$settings.hebrew
      }   
    },
    watch: {
      loading: function() {
        if (this.loading === 'Complete') {
          this.showNoResults = false
        }  
      }  
    }      
  }
</script>

<style scoped lang="scss">
  .bible-results {   
    .frame-area{
      min-height:435px;
      border-radius: 6px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);   
    }
  }
</style>
